export const dataReducer = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_PATTERN': {
      return {
        ...state,
        ...action.data
      }
    }
    case 'ADD_ANSWER_VARIANT': {
      const { answerVariants } = state
      const { item, position } = action.data
      answerVariants.splice(position, 0, item)

      return {
        ...state,
        answerVariants
      }
    }
    case 'UPDATE_ANSWER_VARIANT': {
      const { answerVariants } = state
      const { item, position } = action.data
      answerVariants[position] = item

      return {
        ...state,
        answerVariants
      }
    }
    case 'UPDATE_ANSWER_VARIANTS_MODE': {
      const { answerVariants } = state
      const { positions, mode } = action.data

      return {
        ...state,
        answerVariants: answerVariants.map((av, index) =>
          positions.includes(String(index + 1))
            ? Object.assign(av, {
                mode: av.other ? 'basic' : mode
              })
            : av
        )
      }
    }
    case 'REORDER_ANSWER_VARIANTS': {
      const { answerVariants } = state
      const { from, to } = action.data
      const item = answerVariants.splice(from, 1)[0]
      answerVariants.splice(to, 0, item)

      return {
        ...state,
        answerVariants
      }
    }
    case 'DELETE_ANSWER_VARIANT': {
      const { answerVariants, errors } = state
      answerVariants.splice(action.data, 1)

      return {
        ...state,
        answerVariants,
        errors: errors.filter(v => 'pattern' == v || action.data >= Number(v.slice(1)))
      }
    }
    case 'UPDATE_LOGIC_DATA': {
      const { logicData } = state
      const path = action.data.id.split('.')
      if (1 < path.length) {
        if (null === action.data.logicData) {
          delete logicData.items[path[0]]
        } else {
          logicData.items[path[0]] ||= {}
          logicData.items[path[0]][path[1]] = action.data.logicData
        }
      } else {
        logicData[path[0]] = action.data.logicData
      }

      return {
        ...state,
        logicData
      }
    }
    case 'UPDATE_REFS': {
      const { refs } = state

      if (null === action.data.refs) {
        delete refs[action.data.id]
      } else refs[action.data.id] = action.data.refs

      return {
        ...state,
        refs
      }
    }
    case 'UPDATE_ERRORS': {
      const { errors } = state
      const id = action.data.id || 'pattern'
      const index = errors.indexOf(id)
      0 <= index && errors.splice(index, 1)
      true == action.data.error && errors.push(id)

      return {
        ...state,
        errors
      }
    }
    case 'RESET': {
      return {
        ...state,
        ...action.data
      }
    }
    default:
      throw new Error('Unknown action type')
  }
}
